module.exports = __webpack_public_path__ + "img/receipt.fbd8937a.svg";